import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-palette-fill text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                韩国漫画<span className="text-accent-400">大全</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              韩国漫画大全是一个按题材分类整理的韩漫推荐门户，聚焦奇幻、校园、古风等专题，帮读者快速定位偏好题材，持续发现同类佳作。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-douban-line", "ri-zhihu-line"].map((ic) => (
                <a
                  key={ic}
                  href="#contact"
                  aria-label="社交平台链接"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-700/60 text-background-200 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={ic} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wide text-accent-400">
              快速导航
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { to: "/", label: "首页" },
                { to: "/about", label: "关于我们" },
                { to: "/contact", label: "联系我们" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-background-200 transition-colors hover:text-background-50">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wide text-accent-400">
              题材专题
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-background-200 transition-colors hover:text-background-50"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-700/70 pt-6 text-sm text-background-300 sm:flex-row">
          <p>© {new Date().getFullYear()} 韩国漫画大全 版权所有</p>
          <p className="text-background-400">本站内容仅供题材导览参考</p>
        </div>
      </div>
    </footer>
  );
}